export default __webpack_public_path__ + "static/appleOnHover-3f5cb9aedcf88242c696ff12b403cd98.svg";